module.exports = __webpack_public_path__ + "static/foro-45807e45b9623a5654ebb0bce59a5db2.jpg";